import { render, staticRenderFns } from "./ViewReseller.vue?vue&type=template&id=59028d7d&"
import script from "./ViewReseller.vue?vue&type=script&lang=js&"
export * from "./ViewReseller.vue?vue&type=script&lang=js&"
import style0 from "./ViewReseller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports